import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const fmtUsd = (n, digits = 2) => {
  if (n == null || isNaN(n)) return "$0";
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return `$${n.toFixed(digits)}`;
};

export const fmtPrice = (n) => {
  if (!n) return "$0";
  if (n < 0.001) return `$${n.toExponential(2)}`;
  if (n < 1) return `$${n.toFixed(5)}`;
  return `$${n.toFixed(3)}`;
};

export const CHAIN_COLORS = {
  Solana: "#14F195",
  Base: "#0052FF",
  BNB: "#F3BA2F",
  Monad: "#836EF9",
  Ethereum: "#627EEA",
  Robinhood: "#00C805",
};

export default api;
